import React from "react";

const Loader = () => {
  return (
    <div className="loader-outer">
      <div className="loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <p>Loading...</p>
    </div>
  );
};

export default Loader;
